import { app } from '../../../../app';
import { Controller } from './app-integration-instructions-local.controller';

app.component('appIntegrationInstructionsLocal', {
    bindings: {
        application: '<',
        appType: '<',
    },
    controller: Controller,
    templateUrl: require('./app-integration-instructions-local.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/app-integration-instructions/local/app-integration-instructions-local.component.js